function initAutocompleteToggle() {
  const searchButton = document.getElementById("js-search-button");
  const autocomplete = document.querySelector("header [data-component=autocomplete-block]");

  if (searchButton && autocomplete) {
    searchButton.addEventListener("click", function () {
      autocomplete.toggleAttribute("open");
    });
  }
}

export default initAutocompleteToggle;



// WEBPACK FOOTER //
// ./components/autocomplete/AutocompleteToggle.js